import React from 'react';
import { Resource, ResourceInfo, ResourceProps } from 'omni-package-react-core';
import transformOnlineTransaction from './transformOnlineTransaction';
import getOnlineTransactionsApiRoot from '../../utils/getOnlineTransactionsApiRoot';
import { OnlineTransactionDto } from '../../interfaces/OnlineTransactionDto';

export const OnlineTransactionResourceInfo: ResourceInfo = {
  name: '/App.features.notifications.onlinetransactionsResource',
  url: `${getOnlineTransactionsApiRoot()}/pending`,
  dataDst: '/App.features.notifications.onlinetransactions',
};

const OnlineTransactionResource = <Data, Error = {}>({ ...props }: ResourceProps<Data, Error>) => (
  <Resource
    {...OnlineTransactionResourceInfo}
    {...props}
    transformResponse={(onlineTransactionDto: OnlineTransactionDto) => transformOnlineTransaction(onlineTransactionDto)}
  />
);

export default OnlineTransactionResource;
